import React, { useState, useEffect } from 'react';
import { TeacherStatCard } from '../../components/Institute-faculty/Dashboard/TeacherStatsCard';
// import { TeacherBatchWiseStudent } from '../../components/Institute-faculty/Dashboard/TeacherBatchWiseStudent';
import { TeacherUpcomingSession } from '../../components/Institute-faculty/Dashboard/TeacherUpcomingSession';
import { TeacherTodaysSessions } from '../../components/Institute-faculty/Dashboard/TeacherTodaySession';
import BatchWiseStudentCount from '../../components/Institute-faculty/Dashboard/BatchWiseStudentCount';
import TeacherProfileCard from '../../components/Institute-faculty/Dashboard/TeacherProfileCard';
import TeacherWelcomeCard from '../../components/Institute-faculty/Dashboard/TeacherWelcomeCard';

const IFDashboard = () => {
  const [stats, setStats] = useState([]);
  const [batchWiseData, setBatchWiseData] = useState([]);
  const [todaysSessions, setTodaysSessions] = useState([]);
  const [weekSessions, setWeekSessions] = useState([]);
  const [batchDetails, setBatchDetails] = useState({});
  const [loading, setLoading] = useState(true);

  const teacher_id = sessionStorage.getItem('id');
  const LMS = process.env.REACT_APP_API_LMS;
  const token = process.env.REACT_APP_API_TOKEN;

  useEffect(() => {
    const loadData = async () => {
      const batchMap = await fetchBatchDetails();
      if (batchMap) {
        await fetchTeacherStats(batchMap);
      }
      setLoading(false);
    };
    
    loadData();
  }, []);

  const fetchTeacherStats = async (batchDetailsMap) => {
    try {
      const response = await fetch(`${LMS}/api/teacher/stats?teacher_id=${teacher_id}`, {
        method: 'GET',
        headers: {
          'Authorization': token,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      const result = await response.json();

      if (result.status && result.data) {
        const { data } = result;

        setStats([
          { id: 1, value: data.total_programs?.toString() || '0', label: 'Total Programs', icon: 'bi bi-journal-code', link: '/enroll-program' },
          { id: 2, value: data.batch_wise_student_count?.reduce((sum, batch) => sum + batch.student_count, 0)?.toString() || '0', label: 'Total Students', icon: 'bi bi-people', link: '/teacher-program-enroll-student' },
          { id: 3, value: data.total_batches?.toString() || '0', label: 'Total Batches', icon: 'bi bi-clock-history', link: '/teacher-batches' },
          { id: 4, value: data.this_week_sessions?.length?.toString() || '0', label: 'This Week Sessions', icon: 'bi bi-calendar-week', link: 'teacher-batches' }
        ]);

        const formattedBatchData = data.batch_wise_student_count?.map(batch => ({
          name: batchDetailsMap[batch.batch_id]?.batch_name || `Batch ${batch.batch_id}`,
          value: batch.student_count,
          batch_id: batch.batch_id
        })) || [];
        setBatchWiseData(formattedBatchData);

        setTodaysSessions(data.todays_sessions || []);
        setWeekSessions(data.this_week_sessions || []);
      }
    } catch (error) {
      console.error('Error fetching teacher stats:', error);
    }
  };

  const fetchBatchDetails = async () => {
    try {
      const response = await fetch(`${LMS}/api/batch/getlist`, {
        method: 'POST',
        headers: {
          'Authorization': token,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          teacher_id: parseInt(teacher_id)
        })
      });

      const result = await response.json();

      if (result.status && result.data && result.data.data) {
        const batchMap = {};
        result.data.data.forEach(batch => {
          batchMap[batch.id] = {
            batch_name: batch.batch_name || `Batch ${batch.id}`,
            program_title: batch.program_title || 'Unknown Program'
          };
        });
        setBatchDetails(batchMap);
        return batchMap; // Return the batch map immediately
      }
      return {};
    } catch (error) {
      console.error('Error fetching batch details:', error);
      return {};
    }
  };

  const handleStartSession = (session) => {
    if (session.meet_url) {
      window.open(session.meet_url, '_blank');
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className='p-2'>
      
      <div className="row g-3 mb-4">
        {/* Welcome card: full width on small screens, 8/12 on md+ */}
        <div className="col-12 col-md-8">
          <TeacherWelcomeCard />
        </div>
        {/* Profile card: full width on small screens, 4/12 on md+ */}
        <div className="col-12 col-md-4">
          <TeacherProfileCard />
        </div>
      </div>
      {/* Stats Cards */}
      <div className="row g-3">
        {stats.map((stat) => (
          <TeacherStatCard
            key={stat.id}
            title={stat.label}
            value={stat.value}
            icon={stat.icon}
            onClick={() => window.location.href = stat.link}
            style={{ cursor: 'pointer' }}
          />
        ))}
      </div>

      {/* Today's Sessions */}
      <div className="row g-2 ">
        <div className="col-12">
          <TeacherTodaysSessions
            sessions={todaysSessions}
            onStartSession={handleStartSession}
            batchDetails={batchDetails}
            maxItems={3}
            from="dashboard"
          />
        </div>
      </div>

      {/* Batch-wise Graph + Upcoming Sessions */}
      <div className="row g-3">
        <TeacherUpcomingSession sessions={weekSessions} batchDetails={batchDetails} />
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card yellowborder rounded-3">
            <div className="card-header yellow-card-header border-bottom-0 py-2 py-md-3">
              <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2">
                <h5 className="fw-bold mb-0 newfont d-flex align-items-center gap-2 text-break w-100">
                  <i className="bi bi-journal-bookmark-fill me-1 me-md-2"></i>
                  Batch Wise Student Enrollment
                </h5>
                <div className='d-flex justify-content-end w-100'>
                <button 
                  onClick={() => window.location.href = '/teacher-program-enroll-student'} 
                  className="btn btn-primary btn-sm px-2 py-1 d-flex align-items-center text-nowrap"
                >
                  <span className="d-none d-sm-inline">View All Enrolled Students</span>
                  <span className="d-inline d-sm-none">View All</span>
                  <i className="bi bi-arrow-right ms-1 ms-md-2"></i>
                </button>
                </div>
              </div>
            </div>
            <div className="card-body p-4">
              <BatchWiseStudentCount 
                batchData={batchWiseData} 
                batchDetails={batchDetails}
                loading={loading} 
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IFDashboard;